import { useEvents } from 'client/widgets/runtime-cal-booking/hooks/useEvents';
import { isPaidBooking } from 'client/widgets/runtime-cal-booking/utils';
import React, { useCallback, useContext } from 'react';
import { useBookingContext } from '../../../Context';
import { BookerStateContext } from '../../../hooks/useRuntimeCalBookingState';
import { CalEventDataWithDisplayPrice } from '../../../types';
import { DudaParagraphWrapper } from '../../ContainerQueryStyles';
import OuterContainer from '../common/OuterContainer';
import { Container, GroupedEventsTitle, StepItemsList } from '../common/styles';
import EventCard from './EventCard';
import EventListSkeleton from './EventListSkeleton';

const SelectEventStep = () => {
    const bookerContext = useBookingContext();
    const [, bookingActions] = useContext(BookerStateContext);
    const { calEventsMap, shouldFetchEvents, isLoading } = useEvents();

    const { events, groupedAppointmentInfo, showFreePrice } = bookerContext;

    const isFetchingEvents = isLoading && shouldFetchEvents;

    const eventsListLabel =
        groupedAppointmentInfo?.title || 'Available services';

    const handleEventSelect = useCallback(
        (event: CalEventDataWithDisplayPrice) => {
            if (isLoading) {
                return;
            }

            bookingActions.setIsLoading(true);
            bookingActions.setEventSlug(event.slug);
            bookingActions.setEventSelection(event);
            bookingActions.resetEditorStep();
        },
        [isLoading, bookingActions]
    );

    return (
        <OuterContainer className='booking-select-events-step'>
            <Container>
                {groupedAppointmentInfo?.isTitleVisible &&
                    groupedAppointmentInfo.title && (
                        <GroupedEventsTitle data-auto='booking-select-events-step-grouped-events-title'>
                            <DudaParagraphWrapper>
                                {groupedAppointmentInfo.title}
                            </DudaParagraphWrapper>
                        </GroupedEventsTitle>
                    )}
                {isFetchingEvents ? (
                    <EventListSkeleton
                        ariaLabel={eventsListLabel}
                        dataAuto='booking-select-events-step-events-list-skeleton'
                        className='defaultList'
                    />
                ) : (
                    <StepItemsList
                        aria-label={eventsListLabel}
                        className='defaultList'
                        data-auto='booking-select-events-step-events-list'
                    >
                        {events.map((event) => (
                            <EventCard
                                key={event.identifier}
                                calEventData={calEventsMap.get(
                                    event.identifier
                                )}
                                identifier={event.identifier}
                                onSelect={handleEventSelect}
                                isPaid={isPaidBooking(event)}
                                showFreePrice={showFreePrice}
                            />
                        ))}
                    </StepItemsList>
                )}
            </Container>
        </OuterContainer>
    );
};

export default SelectEventStep;
